import { render, staticRenderFns } from "./treeChange.vue?vue&type=template&id=85843a1e"
import script from "./treeChange.vue?vue&type=script&lang=js"
export * from "./treeChange.vue?vue&type=script&lang=js"
import style0 from "./treeChange.vue?vue&type=style&index=0&id=85843a1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports